// @ts-strict-ignore
import {getCookie} from 'common/util/cookie';

class MpFetchError extends Error {
  constructor(error) {
    super(error.message);
    this.name = error.name;
    this.stack = error.stack;
    Object.assign(this, error);
  }
}

const csrfSafeMethod = (method) => /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
const isSameOrigin = (request) => {
  let url = request;
  if (typeof request !== `string`) {
    url = request.url;
  }

  return url.startsWith(`/`) || (url.startsWith(`https://`) && window.location.origin === new URL(url).origin);
};

// don't double patch fetch
if (!window[`_fetch`]) {
  const csrfToken = getCookie(`csrftoken`);

  if (window[`$`]) {
    // jquery hook, if jquery is present
    $.ajaxSetup({
      beforeSend(xhr, settings) {
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
          xhr.setRequestHeader(`X-CSRFToken`, csrfToken);
          xhr.setRequestHeader(`X-Requested-With`, `XMLHttpRequest`);
        }
      },
    });
  }

  // patch window.fetch to always send X-CSRF header on same-origin requests that can modify resources
  window[`_fetch`] = window.fetch;
  window.fetch = async function (url, options = {}) {
    const method = options && options.method;
    // same-origin check so we're not sending csrf tokens to non mixpanel.com domains
    if (!csrfSafeMethod(method) && isSameOrigin(url)) {
      const headers = {...options.headers, 'X-CSRFToken': csrfToken};
      options = {...options, headers, credentials: `same-origin`};
    }

    try {
      const response = await window[`_fetch`](url, options);
      return response;
    } catch (error) {
      throw new MpFetchError(error);
    }
  };
}
